import React, { useEffect, useRef } from 'react'
import { useState } from 'react'
import { getLoomId, getYoutubeId, PROVIDER_LOOM, PROVIDER_YOUTUBE } from '../player'
import PlayerButton from '../playerButton'

// Hook
function useOnScreen(ref, rootMargin = '0px') {
  // State and setter for storing whether element is visible
  const [isIntersecting, setIntersecting] = useState(false)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // Update our state when observer callback fires
        setIntersecting((prevState) => prevState || entry.isIntersecting)
      },
      {
        rootMargin,
      }
    )
    if (ref.current) {
      observer.observe(ref.current)
    }
    return () => {
      if (ref.current) observer.unobserve(ref.current)
    }
  }, []) // Empty array ensures that effect is only run on mount and unmount
  return isIntersecting
}

function PlayerScreen(props) {
  const { image, alt, video, className = '' } = props

  const ref = useRef()
  const onScreen = useOnScreen(ref, '200px 0px 200px 0px')
  const [displayVideo, setDisplayVideo] = useState(false)

  useEffect(() => {
    if (typeof window !== 'undefined') if (/firefox/i.test(navigator.userAgent)) setLoading(false)
  }, [])

  const [loading, setLoading] = useState(true)

  return (
    <div className={`player-container__screen ${className}`} ref={ref}>
      <div className={`player-screen ${loading ? 'player-screen--loading' : ''}`}>
        {onScreen && (
          <>
            {video && video.provider_name !== PROVIDER_LOOM && !displayVideo && !loading && (
              <PlayerButton onClick={() => setDisplayVideo(true)} />
            )}
            <div className="player-screen__iframe">
              {displayVideo && video.provider_name === PROVIDER_YOUTUBE && (
                <>
                  <iframe
                    title={video.embed_url}
                    src={`//www.youtube.com/embed/${getYoutubeId(video.embed_url)}?autoplay=1`}
                    allowFullScreen
                    allow="autoplay"
                    onLoad={() => setLoading(false)}
                    on
                  />
                  <img className="img-disabled" loading="lazy" src={image} alt={alt} />
                </>
              )}
              {video.provider_name === PROVIDER_LOOM && (
                <>
                  {loading && (
                    <span className="player-screen__loading">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        x="0"
                        y="0"
                        version="1.1"
                        viewBox="0 0 100 100"
                        xmlSpace="preserve"
                      >
                        <path
                          fill="#fff"
                          d="M73 50c0-12.7-10.3-23-23-23S27 37.3 27 50m3.9 0c0-10.5 8.5-19.1 19.1-19.1S69.1 39.5 69.1 50"
                        >
                          <animateTransform
                            attributeName="transform"
                            attributeType="XML"
                            dur="1s"
                            from="0 50 50"
                            repeatCount="indefinite"
                            to="360 50 50"
                            type="rotate"
                          ></animateTransform>
                        </path>
                      </svg>
                    </span>
                  )}
                  <iframe
                    title={video.embed_url}
                    src={`https://www.loom.com/embed/${getLoomId(video.embed_url)}${
                      displayVideo
                        ? '?autoplay=1'
                        : '?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true'
                    }`}
                    allowFullScreen
                    onLoad={() => setLoading(false)}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default PlayerScreen
